"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var rxjs_1 = require("rxjs");
exports.Subject = rxjs_1.Subject;
//# sourceMappingURL=Subject.js.map